// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ny-0";
export var discountCodeInput = "_ny-1";